"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function useSettings() {
	const { theme, setTheme, systemTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		// Set mounted to true after the component mounts
		setMounted(true);
	}, []);

	const toggleTheme = () => {
		// Toggle theme
		setTheme(theme === "dark" ? "light" : "dark");
	};

	const isThemeManual = theme !== "system";

	return {
		theme,
		systemTheme,
		isThemeManual,
		toggleTheme,
		mounted,
	};
}
